var ngMenu = angular.module('ng.navigation', []);
ngMenu.directive('angularMenu', [
    'preLoadedData',
    '$state',
    '$timeout',
    '$location',
    'userStorage',
    '$rootScope',
    function (preLoadedData, $state, $timeout, $location, userStorage, $rootScope) {
        return {
            restrict: 'E',
            templateUrl: 'views/templates/left_menu/menu.html',
            replace: true,
            compile: function (menuWrapper) {
                return function ($scope) {
                    //angular.copy(preLoadedData.data.menu);

                    $scope.$watch(function(){ return $scope.location = $location.$$path.split('/')[1]; });

                    $scope.menuItems = [
                        {
                            state: "main.skins.list",
                            label: "left_menu.skins.list",
                            cssClass: "skin viewSkins"
                        },
                        {
                            state: "main.monitoring",
                            label: "left_menu.monitoring.list",
                            cssClass: "monitoring viewMonitoringTool"
                        },
                        {
                            state: "main.topMatch",
                            label: "left_menu.topMatches.moduleLabel",
                            cssClass: "topMatches",
                            abstract: true,
                            subMenu: [
                                {
                                    state: "main.topMatch.list",
                                    label: "left_menu.topMatches.label",
                                    cssClass: "topMatches"
                                }
                            ]
                        },
                        {
                            state: "main.media.list",
                            label: "left_menu.media.list",
                            cssClass: "viewMedia fa-picture-o"
                        },
                        {
                            state: "main.popups.list",
                            label: "left_menu.popups.list",
                            cssClass: "viewPopups fa-window-restore"
                        },
                        {
                            state: "main.users.list",
                            label: "left_menu.users.list",
                            cssClass: "allUsers fa-user"
                        },
                        {
                            state: "pages",
                            label: "left_menu.pages.label",
                            cssClass: "fa-th-large",
                            abstract: true,
                            subMenu: [
                                {
                                    state: "main.pages.list.banners",
                                    label: "left_menu.pages.List.banners",
                                    cssClass: "blocksAllBanners viewBanners"
                                },
                                {
                                    state: "main.pages.list.news",
                                    label: "left_menu.pages.List.news",
                                    cssClass: "blocksAllNews viewNews"
                                },
                                {
                                    state: "main.pages.list.promos",
                                    label: "left_menu.pages.List.promos",
                                    cssClass: "blocksAllNews viewPromotions"
                                },
                                {
                                    state: "main.pages.list.texts",
                                    label: "left_menu.pages.List.texts",
                                    cssClass: "blocksAllTexts viewPages"
                                },
                                {
                                    state: "main.pages.list.backgrounds",
                                    label: "left_menu.pages.List.backgrounds",
                                    cssClass: "blocksAllBackgrounds viewBackgrounds"
                                }
                            ]
                        },
                        {
                            state: "main.pageBuilders",
                            label: "left_menu.pageBuilders.pageBuilders",
                            cssClass: "pageBuilders",
                            abstract: true,
                            subMenu: [
                                {
                                    state: "main.pageBuilders.liveCasino",
                                    label: "left_menu.pageBuilders.liveCasino",
                                    cssClass: "viewLiveCasinoBuilder"
                                },
                                {
                                    state: "main.pageBuilders.skillGames",
                                    label: "left_menu.pageBuilders.skillGames",
                                    cssClass: "viewSkillGamesBuilder"
                                }
                            ]
                        },
                        {
                            state: "main.applications",
                            label: "left_menu.applications.label",
                            cssClass: "applications",
                            abstract: true,
                            subMenu: [
                                {
                                    state: "main.applications.androidAppSkinning",
                                    label: "left_menu.applications.androidAppSkinning",
                                    cssClass: "viewAndroidAppBuilder"
                                },
                                {
                                    state: "main.applications.androidAppSettings",
                                    label: "left_menu.applications.androidAppSettings",
                                    cssClass: "viewAndroidAppSettings"
                                },
                                {
                                    state: "main.applications.iosAppSettings",
                                    label: "left_menu.applications.iosAppSettings",
                                    cssClass: "viewIosAppSettings"
                                },
                                {
                                    state: "main.applications.androidPromoApp",
                                    label: "left_menu.applications.androidPromoApp",
                                    cssClass: "viewAndroidPromoApp"
                                }
                            ]
                        },
                        {
                            state: "main.configs",
                            label: "left_menu.configs",
                            cssClass: "fa-sliders",
                            abstract: true,
                            subMenu: [
                                {
                                    state: "main.configs.availableConfigs",
                                    label: "left_menu.availableConfigs",
                                    cssClass: "viewAvailableSystemSettings"
                                },
                                {
                                    state: "main.configs.general",
                                    label: userStorage.getUserData().permissions.indexOf('viewSkinSettings') !== -1? "left_menu.skinConfigs": "left_menu.mainConfigs",
                                    cssClass: "viewSystemSettings viewSkinSettings"
                                },
                                {
                                    state: "main.configs.skinConfigs",
                                    label: "left_menu.availableSkinSettings",
                                    cssClass: "viewAvailableSkinSettings"
                                },
                                {
                                    state: "main.configs.availableMobileConfigs",
                                    label: "left_menu.mobileAvailableConfigs",
                                    cssClass: "viewMobileAvailableSystemSettings"
                                },
                                {
                                    state: "main.configs.generalMobile",
                                    label: userStorage.getUserData().permissions.indexOf('viewMobileSkinSettings') !== -1? "left_menu.mobileSkinConfigs": "left_menu.mobileMainConfigs",
                                    cssClass: "viewMobileSystemSettings viewMobileSkinSettings"
                                },
                                {
                                    state: "main.configs.skinMobileConfigs",
                                    label: "left_menu.mobileAvailableSkinSettings",
                                    cssClass: "viewMobileAvailableSkinSettings"
                                }

                            ]
                        },
                        {
                            state: "main.payments",
                            label: "left_menu.payments",
                            cssClass: "viewPayments payments"
                        },
                        {
                            state: "main.skinPayments",
                            label: "left_menu.payments",
                            cssClass: "viewSkinPayments skinPayments"
                        },
                        {
                            state: "main.design",
                            label: "left_menu.design",
                            cssClass: "fa-paint-brush",
                            abstract: true,
                            subMenu: [
                                {
                                    state: "main.design.customCss",
                                    label: "left_menu.design.customCss",
                                    cssClass: "viewCustomCss"
                                },
                                {
                                    state: "main.design.mobileCustomCss",
                                    label: "left_menu.design.mobileCustomCss",
                                    cssClass: "viewMobileCustomCss"
                                },
                                {
                                    state: "main.design.logo",
                                    label: "left_menu.design.logo",
                                    cssClass: "viewLogo"
                                }
                            ]
                        },
                        {
                            state: "main.styles",
                            label: "left_menu.styles",
                            closeMain: true,
                            cssClass: "fa-paint-brush"
                        },
                        {
                            state: "main.products",
                            label: "left_menu.products.label",
                            cssClass: "fa-cubes",
                            abstract: true,
                            subMenu: [
                                {
                                    state: "main.products.exchange",
                                    label: "left_menu.products.exchangeShop",
                                    cssClass: "viewProducts"
                                },
                                {
                                    state: "main.products.loyalty",
                                    label: "left_menu.products.loyaltyPoints",
                                    cssClass: "viewLoyaltyPoints"
                                },
                            ]
                        },
                        {
                            state: "main.reset",
                            label: "left_menu.skins.reset",
                            cssClass: "reset"
                        },


                        {
                            state: "main.games,main.providers,main.categories,main.features,main.themes,main.gameReleases,main.casinoSettings",
                            label: "left_menu.casino",
                            cssClass: "fa-gamepad",
                            abstract: true,
                            subMenu: [
                                {
                                    state: "main.providers.list",
                                    label: "left_menu.providers.label",
                                    cssClass: "provider viewGameProviders"
                                },
                                {
                                    state: "main.categories.list",
                                    label: "left_menu.categories.label",
                                    cssClass: "category viewGameCategories"
                                },
                                {
                                    state: "main.themes.list",
                                    label: "left_menu.themes.label",
                                    cssClass: "viewGameThemes"
                                },
                                {
                                    state: "main.features.list",
                                    label: "left_menu.features.label",
                                    cssClass: "viewGameFeatures"
                                },
                                {
                                    state: "main.games.list",
                                    label: "left_menu.games.list",
                                    cssClass: "allGames viewAllGames"
                                },
                                {
                                    state: "main.skinGames.list",
                                    label: "left_menu.skinGames.list",
                                    cssClass: "allSkinGames viewAllSkinGames"
                                },
                                {
                                    state: "main.gameReleases.list",
                                    label: "left_menu.gameReleases.list",
                                    cssClass: "gameReleases viewGameReleases"
                                },
                                {
                                    state: "main.games.join",
                                    label: "left_menu.games.joinGames",
                                    cssClass: "joinGames viewJoinGames"
                                },
                                {
                                    state: "main.games.gamesreference",
                                    label: "left_menu.games.gamesreference",
                                    cssClass: "gamesReference viewGamesReference"
                                },
                                {
                                    state: "main.games.categoriesAndProviders",
                                    label: "left_menu.games.gamesCategoriesAndProviders",
                                    cssClass: "gamesCategoriesAndProviders viewCategoriesProviders"
                                },
                                {
                                    state: "main.games.casinoJackpotBanners",
                                    label: "left_menu.games.casinoJackpotBanners",
                                    cssClass: "viewCasinoJackpotBanners"
                                },
                                {
                                    state: "main.casinoSettings",
                                    label: "left_menu.casinoSettings",
                                    cssClass: "casinoSettings viewCasinoSettings"
                                },
                            ]
                        },
                        {
                            state: "main.report",
                            label: "left_menu.report.label",
                            cssClass: "report",
                            abstract: true,
                            subMenu: [
                                {
                                    state: "main.report.skinsAndProviders",
                                    label: "left_menu.report.skinsAndProviders",
                                    cssClass: "skinsAndProviders viewSkinsProvidersReport"
                                },
                                {
                                    state: "main.report.games",
                                    label: "left_menu.report.games",
                                    cssClass: "games viewGamesReport"
                                }
                            ]
                        },
                        {
                            state: "main.casinoGames",
                            label: "left_menu.casinoGames.label",
                            cssClass: "fa-gamepad",
                            abstract: true,
                            subMenu: [
                                {
                                    state: "main.casinoGames.list",
                                    label: "left_menu.casinoGames.list",
                                    cssClass: "viewSkinGames"
                                },
                                {
                                    state: "main.hiddenGames",
                                    label: "left_menu.hiddenGames.label",
                                    cssClass: "viewSkinCategoriesProviders"
                                },
                                {
                                    state: "main.casinoGames.skinGameWinners",
                                    label: "left_menu.casinoGames.skinGameWinners.label",
                                    abstract: true,
                                    cssClass: "skinGameWinners",
                                    subMenu : [
                                        {
                                            state: "main.casinoGames.skinGameWinners.list",
                                            label: "left_menu.casinoGames.skinGameWinners.list",
                                            cssClass: "skinGameWinnersList"
                                        },
                                        {
                                            state: "main.casinoGames.skinGameWinners.add",
                                            label: "left_menu.casinoGames.skinGameWinners.add",
                                            cssClass: "skinGameWinnersAdd"
                                        }
                                    ]
                                }
                            ]
                        }
                    ];
                    var currentActive;
                    var isClickFired = false;
                    $timeout(function () {
                        $(menuWrapper).find("a").on("click", function () {
                            if (!!$(this).attr("ui-sref")) {
                                if (!isClickFired) {
                                    $rootScope.env = {};
                                } else {
                                    isClickFired = false;
                                }
                                if (!!currentActive && !currentActive.not($(this).closest(".menuItem")).length) {
                                    currentActive.find("a[ui-sref].active").toggleClass("active").parent("li").toggleClass("active");

                                } else {
                                    $(this).parent("li").parent().find("li.active").removeClass("active");

                                    currentActive && currentActive.find(".active").removeClass("active");
                                    currentActive = $(this).closest(".menuItem");
                                    currentActive.children("a").toggleClass("active");

                                }
                                $(this).not(currentActive.children("a")).parent("li").add($(this).not(currentActive.children("a"))).toggleClass("active");
                            } else {
                                var previousActive = $(this).parent("li").parent().find("li.active");
                                var parent = $(this).parent("li");
                                if(previousActive[0] === parent[0]) {
                                    parent.add(!$(this).parent("li").hasClass("menuItem") && $(this)).toggleClass("active");
                                } else {
                                    previousActive.removeClass("active");
                                    parent.add(!$(this).parent("li").hasClass("menuItem") && $(this)).toggleClass("active");
                                }
                            }
                        });
                        getOpenedMenuItem();
                    });

                    function getOpenedMenuItem () {
                        var currentState = $state.$current.name;
                        $(menuWrapper).find("a").each(function () {
                            if ($(this).attr("ui-sref") === currentState) {
                                if (currentState == "main.configs.skinConfigs" ||
                                    currentState == "main.configs.skinMobileConfigs" ||
                                    currentState == "main.configs.general" ||
                                    currentState == "main.configs.generalMobile" ||
                                    currentState == "main.styles") {
                                    $("body").removeClass("menu-opened");
                                    $scope.$digest($scope.menu_switcher = true);
                                }
                                isClickFired = true;
                                return $(this).click();
                            }
                        })
                    }

                    $scope.$watch("menu_switcher", function (newVal, oldVal) {
                        if (!!newVal) {
                            $("body").removeClass("menu-opened");
                        } else {
                            $("body").addClass("menu-opened");
                        }
                    });

                    $scope.rendered = function () {
                        $scope.$broadcast("menu:rendered")
                    }

                }
            }
        }
    }
]).directive('menu', [
    '$timeout',
    '$state',
    function ($timeout, $state) {
        return {
            restrict: 'E',
            templateUrl: function () {
                if ($state.current.name === "main.configs.general" || $state.current.name === 'main.configs.availableConfigs') {
                    return 'views/templates/configs_menu/menu.html'
                }  if ($state.current.name === "main.configs.generalMobile" || $state.current.name === 'main.configs.availableMobileConfigs') {
                    return 'views/templates/configs_menu/mobile/menu.html'
                } else if ($state.current.name === "main.configs.skinConfigs") {
                    return 'views/templates/configs_menu/skinConfigMenu.html'
                }  else if ($state.current.name === "main.configs.skinMobileConfigs") {
                    return 'views/templates/configs_menu/mobile/skinConfigMenu.html'
                } else if ($state.current.name === "main.logo") {
                    return 'views/templates/logo_menu/menu.html'
                }
                return 'views/templates/styles_menu/menu.html'
            },
            replace: true,
            link: function (scope, menuWrapper) {
                menuWrapper = $(menuWrapper);

                function init (reseting) {
                    $timeout(function () {
                        $(menuWrapper).find("li").off('click', clickHandler).on("click", clickHandler);
                    });
                }

                init();

                if ($state.current.name !== "main.configs.general" ||
                    $state.current.name !== "main.configs.generalMobile" ||
                    $state.current.name !== "main.configs.skinConfigs" ||
                    $state.current.name !== "main.configs.skinMobileConfigs" ||
                    $state.current.name !== "main.configs.availableConfigs" ||
                    $state.current.name !== "main.configs.availableMobileConfigs"
                ) {
                    var watcher = scope.$watch('menuItems', function (newVal, oldVal) {
                        if (newVal !== oldVal && !!newVal) {
                            init();
                        }
                    })
                }

                function clickHandler (e) {
                    if ($(this).find("form:visible").length) {
                        return
                    }
                    var other_active_menu = menuWrapper.find("li.active.menu_item").length && menuWrapper.find("li.active.menu_item").not($(this));
                    if ($(this).hasClass("menu_item") && other_active_menu && other_active_menu.length) {
                        other_active_menu.toggleClass("active");
                        other_active_menu.find(".active").toggleClass("active");
                    }
                    $(this).parent().find(".active").not($(this)).toggleClass("active");
                    if ($(this).find("ul").length) {
                        $(this).find(".active").toggleClass("active");
                        if (scope.configData && scope.configData.configSkinId && $(this).find("ul").find("[config-skin-id='" + scope.configData.configSkinId + "']").length) {
                            $(this).find("ul").find("[config-skin-id='" + scope.configData.configSkinId + "']").addClass("active");
                        }
                        $(this).toggleClass("active")
                    } else {
                        $(this).toggleClass("active");
                    }
                }

                scope.$on("resetConfigDirective", function () {
                    init(true);
                });

                scope.$on("$destroy", function () {
                    watcher && watcher();
                })
            }
        }
    }
]);
